{
  "sitemap": {
    "sitemap": "Mapa del sitio",
    "title": {
      "create": "Crear mapa del sitio",
      "edit": "Editar mapa del sitio"
    },
    "name": "Nombre",
    "key": "Código clave (3 letras)",
    "colour_of_label": "Color de la etiqueta",
    "versions": "Versiones",
    "there_are_no_versions": "No hay versiones en este mapa del sitio",
    "add_version": "Agregar versión",
    "map_order": "Orden de los mapas"
  },
  "sitemapVersion": {
    "sitemapVersion": "Versión del mapa del sitio",
    "title": {
      "create": "Crea una versión del mapa del sitio",
      "edit": "Editar una versión del mapa del sitio"
    },
    "version": "Versión",
    "name": "Nombre",
    "level_abbreviation": "Abreviatura de nivel (máximo 3 caracteres)",
    "level_index": "Índice",
    "tiles": "Azulejos",
    "upload_tiles": "Subir mosaicos",
    "remove_tiles": "Eliminar mosaicos",
    "style": "Estilo",
    "upload_style": "Estilo de carga",
    "remove_style": "Eliminar estilo",
    "levels": "Niveles",
    "there_are_no_levels": "No hay niveles en esta versión",
    "add_level": "Agregar nivel",
    "uploading_tiles": "Subiendo {{ level }}",
    "retry": "Vuelva a intentarlo",
    "enter_level_name": "Introduzca el nombre del nivel",
    "level_index_must_be_unique": "El índice de nivel debe ser único",
    "Pending": "Pendiente",
    "Active": "Activo",
    "Deleted": "Eliminado",
    "Uploading": "Subiendo",
    "Extracting": "Extrayendo",
    "Reviewing": "Revisando",
    "Tiling": "Mosaico",
    "Failed": "Falló",
    "deleteVersionWarning": "Un mapa del sitio debe tener al menos una versión. Crea una nueva versión antes de eliminarla"
  },
  "sitemapVersionLevel": {
    "sitemapVersionLevel": "Nivel de versión del mapa del sitio",
    "level": "Nivel"
  },
  "levelsReassignmentDialog": {
    "title": "Reasignación de nivel",
    "paragraph1": "Está a punto de eliminar algunos niveles, pero es posible que existan algunos objetos de mapa en estos niveles.",
    "paragraph2": "¿A qué niveles desea moverlos?"
  },
  "cad": {
    "cadFile": "Archivo CAD",
    "remove": "Archivo DWG",
    "upload": "Cargar archivo DWG",
    "coordinateSystem": "Sistema de coordenadas",
    "preset": {
      "title": "Configuración preestablecida",
      "placeholder": "Seleccione uno de los niveles de versión existentes del mapa del sitio"
    }
  },
  "sitemap_default": {
    "floor": "Planta baja"
  }
}